/**
 * Frontend feature flags.
 * Env values are strings; only the literal "true" (case-insensitive) enables a flag.
 * Unset / any other value => false.
 */
const envFlag = (value: string | undefined): boolean =>
  String(value || "false").trim().toLowerCase() === "true";

/** TPA simulated portal webview on visit stages + LOGIN URL in Hospital Credentials. */
export const ENABLE_TPA_PORTAL_WEBVIEW = envFlag(
  process.env.REACT_APP_ENABLE_TPA_PORTAL_WEBVIEW
);
